import { Formik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { RoundButton } from '@/components/UI/RoundButton';
import { PasswordField } from '@/components/UI/PasswordField';
import { strongPasswordRegex } from '@/helpers/common';
import './index.scss';

const VALIDATION_SCHEMA = t =>
  Yup.object().shape({
    password1: Yup.string()
      .matches(strongPasswordRegex, t('recover_password.val_password_requirements'))
      .required(t('recover_password.val_password_required')),
    password2: Yup.string()
      .oneOf([Yup.ref('password1')], t('recover_password.val_passwords_must_match'))
      .required(t('recover_password.val_confirm_required')),
  });

const INITIAL_VALUES = {
  password1: '',
  password2: '',
};

const RecoverPasswordForm = ({ onSubmit }) => {
  const { t } = useTranslation('auth');

  return (
    <Formik
      initialValues={INITIAL_VALUES}
      validationSchema={VALIDATION_SCHEMA(t)}
      onSubmit={(values, formikBag) => onSubmit(values, formikBag)}
    >
      {({ values, errors, touched, handleChange, handleSubmit, setFieldValue }) => (
        <form onSubmit={handleSubmit}>
          <h1 className="recover-password_form__title f-500">{t('recover_password.title')}</h1>
          <PasswordField
            label={t('recover_password.new_password')}
            name="password1"
            onChange={handleChange}
            value={values.password1}
            onClear={() => setFieldValue('password1', '')}
            error={errors.password1 && touched.password1 && errors.password1}
            withValidation
            className="recover-password_form__password"
          />
          <PasswordField
            label={t('recover_password.confirm_password')}
            name="password2"
            onChange={handleChange}
            value={values.password2}
            onClear={() => setFieldValue('password2', '')}
            error={errors.password2 && touched.password2 && errors.password2}
            className="recover-password_form__password"
          />
          <RoundButton
            label={t('recover_password.submit')}
            name="password2"
            onSubmit={handleSubmit}
            className="recover-password_form__submit"
            fillBackground
            fullWidth
            type="submit"
          />
        </form>
      )}
    </Formik>
  );
};

export default RecoverPasswordForm;
